import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyS, HeadlineL } from '@sorare/core/src/atoms/typography';
import { ClubShopItemStatus } from '@sorare/core/src/components/clubShop/ClubShopItemStatus';

import type { Details_shopItem } from './__generated__/index.graphql.ts';

const Root = styled(Vertical).attrs({ gap: 0, center: true })`
  justify-content: flex-start;
`;

type Props = {
  item: Details_shopItem;
  itemEquipped?: boolean;
};

export const Details = ({ item, itemEquipped }: Props) => {
  return (
    <Root>
      <ClubShopItemStatus status={itemEquipped ? 'equipped' : 'owned'} />
      <HeadlineL as="h3">{item.name}</HeadlineL>
      <Vertical gap={2}>
        <BodyS color="var(--c-nd-400)" as="p" className="text-center">
          {item.description}
        </BodyS>
      </Vertical>
    </Root>
  );
};

Details.fragments = {
  shopItem: gql`
    fragment Details_shopItem on ClubShopItem {
      ... on ShopItemInterface {
        id
        name
        description
      }
    }
  ` as TypedDocumentNode<Details_shopItem>,
};
